export default __webpack_public_path__ + "static/Text-alternatives-DO_6-e11b10dc1e347e4af64b89cdbaabe182.png";